import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
// import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderPreviewData } from '../../../../order-preview.component';

@Component({
  selector: 'app-cash',
  templateUrl: './cash.component.html',
  styleUrls: ['./cash.component.scss'],
})
export class CashComponent implements OnInit, OnDestroy {
  private readonly moneyValuePattern: string = "^\\d*[\\,\\.]?\\d{0,2}$";
  private readonly destroyed$: Subject<void> = new Subject();

  @Input({ required: true }) data!: OrderPreviewData;

  received: FormControl<number> = new FormControl();
  change: number = 0;
  modal!: HTMLIonModalElement;

  constructor(
    private modalController: ModalController,
    // private keyboard: Keyboard,
  ) { }

  ngOnInit(): void {
    this.received.setValidators([
      Validators.min(parseFloat(this.data.order.order.totalPrice)),
      Validators.pattern(this.moneyValuePattern),
      Validators.nullValidator,
      Validators.required]);

    this.modalController.getTop().then((modal) => {
      this.modal = modal!;
      this.modal.breakpoints = [0, 0.75, 0.9];
    });

    this.received.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((value) => this.change = value - parseFloat(this.data.order.order.totalPrice));

    // this.keyboard.onKeyboardHide()
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe(() => this.modal.setCurrentBreakpoint(0.75));

    // this.keyboard.onKeyboardShow()
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe(() => this.modal.setCurrentBreakpoint(0.9));
  }

  ngOnDestroy(): void {
    this.modal.breakpoints = [0, 0.75];
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
